const educationprograms = {
	title: "Utdanningsprogram",
	new_educationprogram: "Nytt program",
	edit_educationprogram: "Rediger programmet: {name}",
	view_ceducationprogram: "Vis program: {name}",
	list_title: "Utdanningsprogrammer",
	list_subtitle: "Endre utdanningsprogram",
	create_title: "Opprett utdanningsprogram",
	update_title: "Endre utdanningsprogram",
	id: "ID",
	name: "Navn",
	code: "Kode",
	date_valid: "Dato aktiv fra",
	status: "Status",
	created_by: "Opprettet av",
};
export default educationprograms;